export const routeLoaders = {
  navRoute: () => import('./NavRoute'),
  workspace: () => import('./App/Workspace'),
  companySettings: () => import('../components/CompanySettings'),
  accountSettings: () => import('../components/account/Settings'),
  updatePassword: () => import('../components/account/UpdatePassword'),
  insights: () => import('../components/insights'),
  insightsDetails: () => import('../components/insights/Details'),
  notFound: () => import('../components/scheduling/NotFound'),
  driverLandingPage: () => import('../components/drivers/DriverLandingPage'),
  gdprCustomerDataReportPage: () => import('../components/Shopify/GdprCustomerDataReportPage'),
  scheduling: () => import('../components/scheduling'),
  driverListing: () => import('../components/drivers/DriverListing'),
  ordersPage: () => import('../components/orders/OrdersPage'),
  customerProfilesPage: () => import('../components/customerProfiles/CustomerProfilesPage'),
} as const;
